import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getRemakeData } from 'services/glass-management/glassManagement';

export const fetchRemakes = createAsyncThunk('glass/remake/fetch', async (filters) => {
    const res = await getRemakeData(filters.start, filters.end);
    return { data: res };
});

export const remakeSlice = createSlice({
    name: 'glassRemake',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchRemakes.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRemakes.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchRemakes.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load remakes';
                state.data = null;
            });
    }
});

export default remakeSlice.reducer;
